import React from "react";
import { Card, Button } from "antd";
import Title from "antd/lib/typography/Title";
import Paragraph from "antd/lib/typography/Paragraph";
import { Link } from "react-router-dom";
import SanitizeHTML from "components/SanitizeHTML/SanitizeHTML";
import fallback from "assets/images/fallbackImg.png";
import { StyledButtonWapper, StyledDiv, StyledImg, StyledTextDiv } from "./style";

interface Props {
  imageLink: string;
  imageAlt: string;
  title: string;
  text: string;
  buttonText: string;
  buttonUrlLink: string;
  downloadable: boolean;
}

const InfoBox: React.FC<Props> = ({ imageLink, imageAlt, title, text, buttonText, buttonUrlLink, downloadable }) => {
  const navigateTo = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  return (
    <>
      <Card
        style={{ maxWidth: "min(360px, 80vw)", height: "100%" }}
        cover={
          <StyledDiv>
            <StyledImg
              src={imageLink}
              alt={imageAlt}
              onError={e => {
                e.currentTarget.src = fallback; // TODO remove this on error parameter?
              }}
            />
            <StyledButtonWapper>
              {downloadable ? (
                <Button
                  onClick={() => navigateTo(buttonUrlLink)}
                  type="primary"
                  size="large"
                  style={{ padding: "10px 30px 32px 30px", fontSize: "1em" }}
                >
                  {buttonText}
                </Button>
              ) : (
                <Link to={buttonUrlLink}>
                  <Button type="primary" size="large" style={{ padding: "10px 30px 32px 30px", fontSize: "1em" }}>
                    {buttonText}
                  </Button>
                </Link>
              )}
            </StyledButtonWapper>
          </StyledDiv>
        }
      >
        <StyledTextDiv>
          <Title level={4}>{title}</Title>
          <Paragraph>
            <SanitizeHTML html={text} />
          </Paragraph>
        </StyledTextDiv>
      </Card>
    </>
  );
};

export default InfoBox;
